<template>
  <div class="component-body">
    <div role="dialog" aria-modal="true" aria-label="Tips" class="el-dialog" style="margin: 0px;">
      <div class="el-dialog__header"><span class="el-dialog__title">Tips</span>
        <button type="button" aria-label="Close" class="el-dialog__headerbtn"><i
            class="el-dialog__close el-icon el-icon-close"></i></button>
      </div>
      <div class="el-dialog__body"><span>This is a message</span></div>
      <div class="el-dialog__footer"><span class="dialog-footer"><button type="button"
                                                                         class="el-button el-button--default"><span>Cancel</span></button><button
          type="button" class="el-button el-button--primary"><span>Confirm</span></button></span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/28/Dialog/index.vue